import ActionType from '../../actions/contactUs/ActionType';


const initialState={
    firm_data:[],
}

const contactUsReducer=(state=initialState, action={})=>{
    switch(action.type){
        case ActionType.FETCH_CONTACT_US:
            return Object.assign({},state,{
                firm_data:action.data,
            });
        default:
            return state;
    }
}

export default contactUsReducer;